import {inject, Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";

@Pipe({
  name: 'unsafeAllowHtml'
})
export class UnsafeAllowHtmlPipe implements PipeTransform {

  protected sanitizer = inject(DomSanitizer);
  transform(value: string|null|undefined) {
    if (!value) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

}
